import {z} from 'zod'
import {Controller, useFormContext} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {SwitchField} from '../switch-field/SwitchField'
import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Switch} from '@/components/commons/switch/Switch'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {RadioSteps} from '@/components/commons/radio-steps/RadioSteps'
import {ObjectKeys} from '@/utilities/helpers'
import {inclusionLevelMapToLabel} from '../../utils'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {StyledSchoolSwitchStepsWrapper} from './style'

const SchoolSwitchStepsSchema = MedicalReportFieldsSchema.pick({
    hasCommunicationAssistant: true,
    inclusionLevel: true
})
type SchoolSwitchStepsSchema = z.infer<typeof SchoolSwitchStepsSchema>

export const SchoolSwitchStepsField = () => {
    const {t} = useTranslation()
    const {control, setValue} = useFormContext<SchoolSwitchStepsSchema>()

    return (
        <Controller
            control={control}
            name="hasCommunicationAssistant"
            render={({field}) => (
                <Flexbox direction="column" gap={4} fullWidth>
                    <SwitchField columns={1} height="58px">
                        <Switch
                            size="sm"
                            label={t('medical_records:communication_assistant')}
                            defaultChecked={field.value}
                            onChange={value => {
                                field.onChange(value)
                                if (!value) {
                                    setValue('inclusionLevel', '')
                                }
                            }}
                        />
                    </SwitchField>
                    {field.value && (
                        <GridItem spanColumn={1} fullWidth>
                            <Controller
                                control={control}
                                name="inclusionLevel"
                                render={({field: inclusionField}) => (
                                    <StyledSchoolSwitchStepsWrapper direction="column" gap={1.5} fullWidth>
                                        <Label>{t('medical_records:inclusion_level')}</Label>
                                        <RadioSteps
                                            name={inclusionField.name}
                                            value={inclusionField.value}
                                            onChange={inclusionField.onChange}
                                            steps={ObjectKeys(inclusionLevelMapToLabel).map(stepKey => ({
                                                value: stepKey,
                                                label: t(inclusionLevelMapToLabel[stepKey])
                                            }))}
                                        />
                                    </StyledSchoolSwitchStepsWrapper>
                                )}
                            />
                        </GridItem>
                    )}
                </Flexbox>
            )}
        />
    )
}
